// import React from "react";
// import "@fortawesome/fontawesome-free/css/all.min.css";

// export default function Booking({
// cards = [
//   {
//     title: "Honda Amaze",
//     company: "Urbania on Rent in Pune",
//     seater: "4+1",
//     priceLabel: "Starting ₹999",
//     desc: "Honda Amaze is a compact sedan known for excellent mileage, smooth riding comfort, and perfect suitability for city travel, office commute, and airport transfers.",
//     image: "/images/fleets/amaze.png",
//   },
//   {
//     title: "Toyota Etios",
//     company: "Urbania on Rent in Pune",
//     seater: "4+1",
//     priceLabel: "Starting ₹999",
//     desc: "Toyota Etios is a reliable sedan offering spacious interiors, strong build quality, and smooth performance, making it ideal for local and outstation trips.",
//     image: "/images/fleets/etios.png",
//   },
//   {
//     title: "Hyundai Aura",
//     company: "Urbania on Rent in Pune",
//     seater: "4+1",
//     priceLabel: "Starting ₹1,099",
//     desc: "Hyundai Aura is a premium compact sedan delivering comfort, safety, and a refined driving experience—perfect for corporate and day-to-day travel.",
//     image: "/images/fleets/aura.png",
//   },
//   {
//     title: "Honda City",
//     company: "Urbania on Rent in Pune",
//     seater: "4+1",
//     priceLabel: "Starting ₹1,299",
//     desc: "Honda City is a premium sedan offering outstanding comfort, executive-level ride quality, and best-in-class cabin space—ideal for business and luxury travel.",
//     image: "/images/fleets/honda-city.png",
//   },
//   {
//     title: "Audi A4",
//     company: "Urbania on Rent in Pune",
//     seater: "4+1",
//     priceLabel: "Starting ₹2,499",
//     desc: "Audi A4 is a luxury sedan offering superior comfort, advanced technology, and a premium travel experience suitable for VIP guests and high-end corporate rides.",
//     image: "/images/fleets/audi.png",
//   },

//   // MPV / SUV
//   {
//     title: "Maruti Suzuki Ertiga",
//     company: "Urbania on Rent in Pune",
//     seater: "7+1",
//     priceLabel: "Starting ₹1,499",
//     desc: "Ertiga is a popular 7-seater MPV offering great space, comfort, and excellent mileage—perfect for family tours and long-distance travel.",
//     image: "/images/fleets/ertiga.png",
//   },
//   {
//     title: "Kia Carens",
//     company: "Urbania on Rent in Pune",
//     seater: "7+1",
//     priceLabel: "Starting ₹1,799",
//     desc: "Kia Carens offers premium interiors, advanced safety, and a smooth driving experience—ideal for luxury family travel and group corporate trips.",
//     image: "/images/fleets/kia.png",
//   },
//   {
//     title: "Toyota Innova",
//     company: "Urbania on Rent in Pune",
//     seater: "7+1",
//     priceLabel: "Starting ₹1,899",
//     desc: "Toyota Innova is India’s most trusted MPV known for reliability, spacious cabin, and unmatched long-distance comfort—perfect for outstation rides.",
//     image: "/images/fleets/innova.png",
//   },
//   {
//     title: "Toyota Innova Crysta",
//     company: "Urbania on Rent in Pune",
//     seater: "7+1",
//     priceLabel: "Starting ₹1,999",
//     desc: "Innova Crysta offers premium ride quality, powerful performance, and luxurious interiors—ideal for business trips, airport pickup, and outstation tours.",
//     image: "/images/fleets/innova-crysta.png",
//   },

//   // Traveller / Buses
//   {
//     title: "Tempo Traveller",
//     company: "Urbania on Rent in Pune",
//     seater: "13+1 / 17+1",
//     priceLabel: "Starting ₹3,500",
//     desc: "Tempo Traveller is perfect for group travel, picnics, office team outings, and long-distance family tours with spacious seating and comfortable interiors.",
//     image: "/images/fleets/tempo-traveller.png",
//   },
//   {
//     title: "Mini Bus",
//     company: "Urbania on Rent in Pune",
//     seater: "20+1 / 26+1",
//     priceLabel: "Starting ₹5,999",
//     desc: "Mini Bus offers excellent comfort for medium-sized groups, suitable for corporate events, weddings, school trips, and outstation group travel.",
//     image: "/images/fleets/mini-bus.png",
//   },
//   {
//     title: "Luxury AC Bus",
//     company: "Urbania on Rent in Pune",
//     seater: "32+1 / 45+1",
//     priceLabel: "Starting ₹8,999",
//     desc: "Luxury AC Bus is ideal for large group travel, corporate tours, pilgrimage trips, and weddings, providing spacious seating and smooth long-distance travel.",
//     image: "/images/fleets/bus.png",
//   },
// ],
// }) {
//   const handleWhatsAppBooking = (title) => {
//     const phone = "919209423113";
//     const message = `Hello Urbania on Rent in Pune, I want to book ${title}. Please share more details.`;
//     const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
//     window.open(url, "_blank");
//   };

//   return (
//     <>





// <div
//       className="breadcumb-wrapper"
//       data-overlay="black"
//       data-opacity="3"
//     >
//       <div className="container">
//         <div className="breadcumb-content text-center">
//           <h1 className="breadcumb-title">Booking</h1>
//         </div>
//       </div>
//     </div>





        

//       {/* ===== Booking Cards ===== */}
//       <section
//         className="taxi-rates-page section-space"
//         style={{ backgroundColor: "#f9fafc", padding: "80px 0" }}
//       >
//         <div className="container">
//           <div className="row g-4 justify-content-center">
//             {cards.map((c, idx) => (
//               <div className="col-xl-4 col-md-6 d-flex" key={idx}>
//                 <div
//                   className="taxi-card d-flex flex-column"
//                   style={{
//                     width: "100%",
//                     backgroundColor: "#fff",
//                     borderRadius: "12px",
//                     overflow: "hidden",
//                     boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
//                     transition: "transform 0.3s ease",
//                     height: "100%",
//                   }}
//                   onMouseEnter={(e) =>
//                     (e.currentTarget.style.transform = "translateY(-6px)")
//                   }
//                   onMouseLeave={(e) =>
//                     (e.currentTarget.style.transform = "translateY(0)")
//                   }
//                 >
//                   {/* Image */}
//                   <div
//                     style={{
//                       backgroundColor: "#EB6157",
//                       padding: "20px",
//                       textAlign: "center",
//                     }}
//                   >
//                     <img
//                       src={c.image}
//                       alt={c.title}
//                       loading="lazy"
//                       style={{
//                         width: "100%",
//                         maxHeight: "220px",
//                         objectFit: "contain",
//                         borderRadius: "8px",
//                       }}
//                     />
//                   </div>

//                   {/* Content */}
//                   <div
//                     style={{
//                       backgroundColor: "#606060",
//                       color: "#fff",
//                       padding: "25px 20px",
//                       flex: "1",
//                     }}
//                     className="d-flex flex-column justify-content-between"
//                   >
//                     <div>
//                       <h3 className="text-center mb-2">{c.title}</h3>
//                       <p
//                         className="text-center mb-4"
//                         style={{ color: "#b0b0b0", fontSize: "0.9rem" }}
//                       >
//                         {c.company}
//                       </p>

//                       {/* ⭐ Seater Row */}
//                       <ul
//                         className="list-unstyled"
//                         style={{
//                           margin: "0 auto 25px auto",
//                           textAlign: "center",
//                           color: "#fff",
//                           fontSize: "1.05rem",
//                           width: "80%",
//                           fontWeight: 600,
//                         }}
//                       >
//                         <li className="d-flex justify-content-center">
//                           Seater: ({c.seater})
//                         </li>
//                       </ul>
//                     </div>

//                     {/* Book Now */}
//                     <div className="text-center mt-auto">
//                       <button
//                         onClick={() => handleWhatsAppBooking(c.title)}
//                         style={{
//                           backgroundColor: "#EB6157",
//                           color: "#fff",
//                           borderRadius: "6px",
//                           padding: "10px 24px",
//                           fontWeight: 600,
//                           gap: "8px",
//                           width: "60%",
//                           border: "none",
//                           cursor: "pointer",
//                           transition: "background 0.3s ease",
//                         }}
//                         onMouseEnter={(e) =>
//                           (e.currentTarget.style.background = "#EB6157")
//                         }
//                         onMouseLeave={(e) =>
//                           (e.currentTarget.style.background = "#EB6157")
//                         }
//                         className="btn d-inline-flex align-items-center justify-content-center"
//                       >
//                         <i className="fab fa-whatsapp" /> Book Now
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>
//     </>
//   );
// }












import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";

export default function Booking({
  cards = [
    {
      title: "Force Urbania 10 Seater",
      company: "Urbania on Rent in Pune",
      seater: "12+1",
      priceLabel: "On Call",
      desc: "Force Urbania 10 Seater offers premium comfort, pushback seats, AC cooling, and smooth suspension—ideal for corporate travel, airport transfers, and small group tours.",
      image: "/images/gallery/1.jpg",
    },
    {
      title: "Force Urbania 14 Seater",
      company: "Urbania on Rent in Pune",
      seater: "14+1",
      priceLabel: "On Call",
      desc: "Urbania 14 Seater is perfect for family tours, corporate outings, and outstation journeys with spacious interiors, premium seating, and superior ride comfort.",
      image: "/images/gallery/2.jpg",
    },
    {
      title: "Force Urbania 17 Seater",
      company: "Urbania on Rent in Pune",
      seater: "17+1",
      priceLabel: "On Call",
      desc: "Urbania 17 Seater is designed for group travel, pilgrimage trips, and long-distance tours, offering luxury seating, AC comfort, and ample luggage space.",
      image: "/images/gallery/3.jpg",
    },
    {
      title: "Luxury Urbania ",
      company: "Urbania on Rent in Pune",
      seater: "12+1 / 14+1",
      priceLabel: "On Call",
      desc: "Luxury Urbania comes with pushback seats, premium interiors, ambient lighting, and enhanced comfort—ideal for VIP guests and luxury group travel.",
      image: "/images/gallery/4.jpg",
    },
    {
      title: "Force Urbania",
      company: "Urbania on Rent in Pune",
      seater: "13+1 / 17+1",
      priceLabel: "On Call",
      desc: "Force Urbania is suitable for budget group travel, school trips, office outings, and family tours with comfortable seating and reliable performance.",
      image: "/images/gallery/5.jpg",
    },
    {
      title: "Luxury AC Bus",
      company: "Urbania on Rent in Pune",
      seater: "32+1 / 45+1",
      priceLabel: "On Call",
      desc: "Luxury AC Bus is best for large group travel, pilgrimage tours, corporate events, and weddings, featuring comfortable seating and long-distance comfort.",
      image: "/images/gallery/6.jpg",
    },
  ],
}) {
  const handleWhatsAppBooking = (title) => {
    const phone = "919209423113";
    const message = `Hello Urbania on Rent in Pune, I want to book ${title}. Please share details.`;
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcumb-wrapper" data-overlay="black" data-opacity="3">
        <div className="container">
          <div className="breadcumb-content text-center">
            <h1 className="breadcumb-title">Urbania Booking</h1>
          </div>
        </div>
      </div>

      {/* Cards */}
      <section
        className="taxi-rates-page section-space"
        style={{ backgroundColor: "#f9fafc", padding: "80px 0" }}
      >
        <div className="container">
          <div className="row g-4 justify-content-center">
            {cards.map((c, idx) => (
              <div className="col-xl-4 col-md-6 d-flex" key={idx}>
                <div
                  className="taxi-card d-flex flex-column"
                  style={{
                    width: "100%",
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    overflow: "hidden",
                    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                    height: "100%",
                  }}
                >
                  {/* Image */}
                  <div style={{ backgroundColor: "#EB6157", padding: "20px" }}>
                    <img
                      src={c.image}
                      alt={c.title}
                      loading="lazy"
                      style={{
                        width: "100%",
                        maxHeight: "220px",
                        objectFit: "contain",
                      }}
                    />
                  </div>

                  {/* Content */}
                  <div
                    style={{
                      backgroundColor: "#606060",
                      color: "#fff",
                      padding: "25px 20px",
                      flex: "1",
                    }}
                    className="d-flex flex-column justify-content-between"
                  >
                    <div>
                      <h3 className="text-center mb-2" 
                      style={{ color: "#EB6157"}}
                      >{c.title}</h3>
                      <p
                        className="text-center mb-3"
                        style={{ color: "#cfcfcf", fontSize: "0.9rem" }}
                      >
                        {c.company}
                      </p>

                      <p className="text-center mb-3 text-white">{c.desc}</p>

                      <p className="text-center fw-bold text-white">
                        Seater: {c.seater}
                      </p>
                    </div>

                    <div className="text-center mt-3">
                      <button
                        onClick={() => handleWhatsAppBooking(c.title)}
                        className="btn d-inline-flex align-items-center justify-content-center"
                        style={{
                          backgroundColor: "#EB6157",
                          color: "#fff",
                          padding: "10px 22px",
                          borderRadius: "6px",
                          border: "none",
                          fontWeight: 600,
                          width: "65%",
                        }}
                      >
                        <i className="fab fa-whatsapp me-2" /> Book Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

